import ActionStore from '@stores/action.store';
import AtomStore from '@stores/atom.store';
import CodeStore from '@stores/code.store';
import { DNDStore } from '@stores/dnd.store';
import EventStore from '@stores/event.store';
import GatewayStore from '@stores/gateway.store';
import ModalStore from '@stores/modal.store';
import { NotificationTemplateStore } from '@stores/notificationTemplate.store';
import { ProcessStore } from '@stores/process.store';
import { TransitionStore } from '@stores/transition.store';
import { VariablesStore } from '@stores/variables.store';
import { WorkflowStore } from '@stores/workflow.store';
import { WorkspaceStore } from '@stores/workspace.store';

import { AnalyticsStore } from './analytics.store';
import DatabaseStore from './database.store';
import { EnvVarStore } from './env-var.store';
import { OrganizationAdminStore } from './organization-admin.store';

export default class RootStore {
  dndStore: DNDStore;
  actionStore: ActionStore;
  analyticsStore: AnalyticsStore;
  variablesStore: VariablesStore;
  processStore: ProcessStore;
  transitionStore: TransitionStore;
  workflowStore: WorkflowStore;
  workspaceStore: WorkspaceStore;
  notificationTemplateStore: NotificationTemplateStore;
  atomStore: AtomStore;
  modalStore: ModalStore;
  codeStore: CodeStore;
  gatewayStore: GatewayStore;
  eventStore: EventStore;
  databaseStore: DatabaseStore;
  envVarStore: EnvVarStore;
  organizationAdminStore: OrganizationAdminStore;

  constructor() {
    this.dndStore = new DNDStore(this);
    this.dndStore.api_enabled = true;
    this.actionStore = new ActionStore(this);
    this.analyticsStore = new AnalyticsStore(this);
    this.variablesStore = new VariablesStore(this);
    this.processStore = new ProcessStore(this);
    this.transitionStore = new TransitionStore(this);
    this.workflowStore = new WorkflowStore(this);
    this.workspaceStore = new WorkspaceStore();
    this.notificationTemplateStore = new NotificationTemplateStore(this);
    this.atomStore = new AtomStore(this);
    this.modalStore = new ModalStore(this);
    this.codeStore = new CodeStore(this);
    this.gatewayStore = new GatewayStore(this);
    this.eventStore = new EventStore(this);
    this.databaseStore = new DatabaseStore(this);
    this.envVarStore = new EnvVarStore();
    this.organizationAdminStore = new OrganizationAdminStore();
  }
}
